"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var Tree_1 = require("../../../components/Tree");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@athena-portal/components");
var moment = require("moment");
var ALLOWED_ROLES = ["Administrator"];
var PendingMtasAction = /** @class */ (function (_super) {
    __extends(PendingMtasAction, _super);
    function PendingMtasAction(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pendingMtas: [],
            loaded: false
        };
        return _this;
    }
    PendingMtasAction.prototype.componentDidMount = function () {
        if (!this.isAuthorized()) {
            this.setState({
                pendingMtas: [],
                loaded: true
            });
            return;
        }
        this.loadPendingMtas();
    };
    PendingMtasAction.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Pending MTAs", children: this.state.pendingMtas.map(function (pendingMta) { return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: new Date(pendingMta.startDate) >= new Date(new Date().setHours(0, 0, 0, 0)) || !pendingMta.startDate ? ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { className: "d-block text-primary", to: ("/journey/show/product/".concat(pendingMta.product, "/process/").concat(pendingMta.process, "/").concat(pendingMta.cdcPage, "/").concat(pendingMta.interactionId)), children: [(0, jsx_runtime_1.jsxs)("div", { children: [pendingMta.process, " - ", pendingMta.cdcPage] }), (0, jsx_runtime_1.jsxs)("div", { children: ["Created: ", _this.formatDate(pendingMta.createdOn), " Updated: ", _this.formatDate(pendingMta.updatedOn)] })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: "d-block text-primary", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "color-red", children: "Expired" }), " ", pendingMta.process, " - ", pendingMta.cdcPage] }), (0, jsx_runtime_1.jsxs)("div", { children: ["Created: ", _this.formatDate(pendingMta.createdOn), " Updated: ", _this.formatDate(pendingMta.updatedOn)] })] })) }, pendingMta.interactionId)); }) }));
    };
    PendingMtasAction.prototype.isAuthorized = function () {
        var _a, _b;
        if (!this.applicationGuard.isAuthenticated()) {
            return false;
        }
        var userRoles = (_b = (_a = this.applicationGuard.getUser()) === null || _a === void 0 ? void 0 : _a.roles) !== null && _b !== void 0 ? _b : [];
        return ALLOWED_ROLES.some(function (allowedRole) { return userRoles.includes(allowedRole); });
    };
    PendingMtasAction.prototype.loadPendingMtas = function () {
        var _this = this;
        this.supportPortalService
            .getPendingMtas(this.props.agreementNumber, this.props.agreementVersionId)
            .subscribe({
            next: function (pendingMtas) {
                _this.setState({
                    pendingMtas: pendingMtas,
                    loaded: true
                });
            },
            error: function () {
                _this.setState({
                    pendingMtas: [],
                    loaded: true
                });
            }
        });
    };
    PendingMtasAction.prototype.formatDate = function (date) {
        return moment.utc(date, moment.ISO_8601).tz("Europe/London").format("DD/MM/YYYY, HH:mm:ss");
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], PendingMtasAction.prototype, "supportPortalService", void 0);
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        __metadata("design:type", Object)
    ], PendingMtasAction.prototype, "applicationGuard", void 0);
    PendingMtasAction = __decorate([
        components_1.authorize,
        components_1.role.apply(void 0, ALLOWED_ROLES),
        __metadata("design:paramtypes", [Object])
    ], PendingMtasAction);
    return PendingMtasAction;
}(React.Component));
exports.default = PendingMtasAction;
//# sourceMappingURL=PendingMtasAction.js.map